import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';
import { selectFinanceOffersByType } from 'state/financeOffers';
import SplitPayLearnMoreView from './SplitPayLearnMoreView';

interface MatchParams {
  offerId: string;
}

const SplitPayLearnMore: React.FC<RouteComponentProps<MatchParams>> = props => {
  const { splitPayOffers } = useSelector(selectFinanceOffersByType);

  const splitPayOffer = useMemo(
    () =>
      splitPayOffers.find(
        splitPayOffer => (splitPayOffer.id = props.match.params.offerId),
      ),
    [splitPayOffers, props.match.params.offerId],
  );

  if (!splitPayOffer) {
    throw new Error('Invalid offer ID');
  }

  return (
    <SplitPayLearnMoreView capacityValue={splitPayOffer.capacityValue / 100} />
  );
};

export default SplitPayLearnMore;
